"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHour = exports.validateCNPJ = exports.validateCPF = void 0;
const react_native_masked_text_1 = require("react-native-masked-text");
const validateCPF = (value) => {
    return react_native_masked_text_1.MaskService.isValid('cpf', value, {});
};
exports.validateCPF = validateCPF;
const validateCNPJ = (value) => {
    return react_native_masked_text_1.MaskService.isValid('cnpj', value, {});
};
exports.validateCNPJ = validateCNPJ;
const isHour = (value) => {
    return /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/.test(value);
};
exports.isHour = isHour;
